/* unplugin-vue-components disabled */import script from "./setting-update-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./setting-update-modal.vue?vue&type=script&setup=true&lang=js"

import "./setting-update-modal.vue?vue&type=style&index=0&id=7c6e6d4b&lang=scss"

const __exports__ = script;

export default __exports__